import React from "react";
import { ItemList } from "../../list/ItemList";
import Image from "../../media/Image";
import { TitleDescriptionText } from "../../typography/TitleDescriptionText";
import { Text } from "../../typography/Text";

export const UserBadge = ({ user, description, append, size }) => {
    return (
        <ItemList bordered>
            <ItemList.Item
                key={user.id}
                value={user}
                prepend={
                    <Image
                        rounded
                        icon="user"
                        iconColor="primary"
                        size={size === "medium" ? "medium" : null}
                        src={user?.picture?.url}
                    />
                }
                append={append}
            >
                <TitleDescriptionText
                    title={
                        <Text size={size === "medium" ? "large" : "medium"} weight="semiBold">
                            {user.fullName}
                        </Text>
                    }
                    description={
                        <Text size={size === "medium" ? "medium" : "regular"} color="base80">
                            {description || user.email}
                        </Text>
                    }
                />
            </ItemList.Item>
        </ItemList>
    );
};
